var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('image-entity-thumbnail-strip');
import { breakpoints } from '@shapeable/theme';
import { ImageEntity } from './image-entity';
import { ResponsiveContainer } from '../elements/responsive-container';
export var ImageEntityThumbnailStripDefaultProps = {
  items: [],
  aspectRatio: {
    base: 21 / 9,
    tablet: 16 / 9,
    desktop: 14 / 9
  }
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background: #000000;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background: #000000;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var itemWidth = _a.itemWidth;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: calc(", "% + 1px);\n      max-height: 400px;\n    "], ["\n      width: calc(", "% + 1px);\n      max-height: 400px;\n    "])), itemWidth);
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(ResponsiveContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Image: styled(ImageEntity)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var ImageEntityThumbnailStrip = function ImageEntityThumbnailStrip(props) {
  var className = props.className,
      items = props.items,
      aspectRatio = props.aspectRatio;
  var itemWidth = 100 / items.length;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (item) {
    return React.createElement(My.Item, {
      key: item.id,
      itemWidth: itemWidth,
      aspectRatio: aspectRatio
    }, React.createElement(My.Image, {
      entity: item
    }));
  }));
};
ImageEntityThumbnailStrip.defaultProps = ImageEntityThumbnailStripDefaultProps;
ImageEntityThumbnailStrip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;